import { Button, Icon, ProgressBar } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './messages';

const FeaturedCourseCard = ({
  title,
  progressPercent,
  courseBadgeText,
  imageUrl,
  onContinue,
  badgeIconSrc,
  ctaLabel,
}) => {
  const intl = useIntl();
  return (
    <div className="featured-course-card">
      <div className="featured-course-card__inner">
        <div
          className="featured-course-card__image"
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          <div className="featured-course-card__imageBadge">
            <Icon className="featured-course-card__imageBadgeIcon" src={badgeIconSrc} size="xs" />
            <span className="featured-course-card__imageBadgeText">{courseBadgeText}</span>
          </div>
        </div>

        <div className="featured-course-card__details">
          <div className="featured-course-card__title">{title}</div>

          <div className="featured-course-card__progressTrack">
            <ProgressBar
              now={progressPercent}
              variant="success"
              label={`${progressPercent}%`}
              srOnly
              className="featured-course-card__progressBar"
            />
          </div>

          <div className="featured-course-card__ctaRow">
            <Button variant="primary" size="lg" onClick={onContinue}>
              {ctaLabel || intl.formatMessage(messages.continueLearning)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedCourseCard;

